export const PZH_CONTRACT = 'pzh';
export const AGENCY_CONTRACT = 'agency';
